import React, { useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Redirect } from "react-router-dom";

// core components

function CovidCards() {
  const [redirectToResource, setRedirectToResource] = useState(false);

  const handleResourcesClick = () => {
    setRedirectToResource(true);
  };

  if (redirectToResource) {
    return <Redirect to="/resources" />;
  }

  return (
    <>
      <div className="section section-sharing section-dark" id="demoPay">
        <Container>
          <Row>
            <div className="title text-center">
              <h3 className="title">Want to contribute?</h3>
              <p className="description">
                You have <b>Free Unlimited Updates</b> and{" "}
                <b>Premium Support</b> on each package for 6 months. You also
                have <b>24 hours</b> to request a refund if you're not happy
                with your purchase.
              </p>
              <br />
            </div>
            <Col className="ml-auto mr-auto" md="8">
              <div className="space-top" />
              <Row>
                <Col md="6">
                  <Card className="card-pricing">
                    <CardBody style={{minHeight: "450px"}}>
                      <div className="card-icon">
                        <span className="icon-simple">
                          <i className="nc-icon nc-globe-2" />
                        </span>
                      </div>
                      <CardTitle tag="h3">Resources</CardTitle>
                      <p className="card-description">
                        For personal websites, school projects, startups or any
                        other project where your users will not be charged for
                        using it. Create one single website/app for one client.
                      </p>
                      <CardFooter style={{position: "absolute", bottom: "40px", left:0, right:0, margin: 'auto'}}>
                        <Button
                          className="btn-round"
                          target="_blank"
                          color="danger"
                          onClick={handleResourcesClick}
                        >
                          Go To Resources
                        </Button>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="6">
                  <Card className="card-pricing">
                    <CardBody style={{minHeight: "450px"}}>
                      <div className="card-icon">
                        <span className="icon-simple">
                          <i className="nc-icon nc-world-2" />
                        </span>
                      </div>
                      <CardTitle tag="h3">Contribute</CardTitle>
                      <p className="card-description">
                        For business projects, multiple websites for clients or
                        for creating themes where your users will be charged for
                        using it. Create multiple websites/apps for multiple
                        clients.
                      </p>
                      <CardFooter style={{position: "absolute", bottom: "40px", left:0, right:0, margin: 'auto'}}>
                        <Button
                          className="btn-round"
                          target="_blank"
                          color="danger"
                          href="https://svastha-dashboard-app.vercel.app/contribute"
                        >
                          Go To Contribution
                        </Button>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col className="offset-md-2 text-center" md="8" />
          </Row>

          {/* <div className="title text-center">
            <h3>Thank you for sharing!</h3>
            <br />
            <Button className="btn-round mr-1" color="twitter" id="twitter">
              <i className="fa fa-twitter mr-1" />
              Twitter
            </Button>
            <Button className="btn-round mr-1" color="facebook" id="facebook">
              <i className="fa fa-facebook-square mr-1" />
              Facebook
            </Button>
            <Button className="btn-round" color="google" id="google">
              <i className="fa fa-google-plus mr-1" />
              Google
            </Button>
          </div> */}
        </Container>
      </div>
    </>
  );
}

export default CovidCards;
